module.exports = __webpack_public_path__ + "static/Grafika6@2x-773232b1e8f8510cb4f705e485e1bbdc.png";